import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IcepanelComponent } from '../icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../icepanel/icepanelcontainer.component';
import { IcecontrolSettings } from '../models/icesettings';

@Component({
  selector: 'icematlist',
  templateUrl: 'icematlist.component.html',
  providers: [IcepanelComponent, IcepanelContainerComponent]
})
export class IcematListComponent {
  @Input() ctrl: IcecontrolSettings = null;
  @Output() addButtonClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() actionClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  getItems(): any[] {
    if (this.ctrl == null) return [];
    return this.ctrl.getOptions();
  }

  getActions(): any[] {
    if (this.ctrl == null) return [];
    return this.ctrl.getActionItems();
  }

  getActionClass(action: any): any {
    if (action == null)
      return { "fas": true, "fa-question": true, "fa-2x": true };

    return action.iconClass;
  }

  getItemClass(icon: any): any {
    if (icon == null)
      return { "fas": true, "fa-question": true };

    return icon;
  }

  onActionButtonClick(event, item: any, action: any) {
    event.matListSettings = this.ctrl;
    event.action = action;
    event.item = item;
    this.actionClick.emit(event);
  }

  addItemClick(event) {
    event.matListSettings = this.ctrl;
    this.addButtonClick.emit(event);
  }
}
